// hooks/useColumnFilter.ts
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers/rootReducer';
import { clearColumnSort, clearFieldSearch, setNotificationLogFilters, setSortModel, setIsFilterOpen } from '../slices/notificationLogSlice';
import { useEffect, useState } from 'react';

export const useColumnFilter = (fieldName: string, headerName: string) => {
    const dispatch = useDispatch();
    const sortModel = useSelector((state: RootState) => 
        state.notificationState.sortModel.find(item => item.field === fieldName)
      );
    const { filters, isFilterOpen } = useSelector((state: RootState) => state.notificationState);
    const currentFilter = filters.find((f) => f.field == fieldName);
    const defaultOperator = headerName === 'DATE/TIMESTAMP' ? 'is' : 'contains';
    const [operator, setOperator] = useState(currentFilter?.operator || defaultOperator);
    const [value, setValue] = useState(currentFilter?.value || '');
    const [date, setDate] = useState<any>()
    const [isFilterActive, setIsFilterActive] = useState(false)

    const handleOnChangeValue = (value?: string) => {
        const updatedValue =  value ?? '';
            setValue(updatedValue);
            dispatch(setNotificationLogFilters({
                field: fieldName,
                operator: operator,
                value: value ?? ''
            }));
    };
    const handleOnDateChangeValue = (value?: string) => {
        const updatedValue =  value ?? '';
            setDate(updatedValue);
            dispatch(setNotificationLogFilters({
                field: fieldName,
                operator: operator,
                value: value ?? ''
            }));
    };

    const handleOperatorChange = (newOperator: string) => {
        setOperator(newOperator);
        if(value.length) {
        dispatch(setNotificationLogFilters({
            field: fieldName,
            operator: newOperator,
            value: value || ''
        }));
        }
    };

    const clearField = () => {
        if(fieldName) {
            dispatch(clearFieldSearch(fieldName))
        }
    }

    const handleSortChange = () => {
        const newSortDirection = sortModel?.sort === 'asc'? 'desc' : 'asc';
        dispatch(setSortModel({
            field: fieldName,
            sort: newSortDirection
        }))
    }
    const handleClearSort = () => {
        dispatch(clearColumnSort(fieldName))
    } 
    const toggleFilter = () => {
        dispatch(setIsFilterOpen(!isFilterOpen));
    }

    useEffect(() => {
        if (currentFilter) {
            setOperator(currentFilter.operator || defaultOperator);
            setValue(currentFilter.value || '');
            setIsFilterActive(true)

        } else {
            setOperator(defaultOperator);
            setValue('');
            setDate('')
            setIsFilterActive(false)
        }
    }, [currentFilter, defaultOperator]);
    return {
        handleOnChangeValue,
        handleOperatorChange,
        defaultOperator, 
        clearField,
        value,
        setValue,
        operator,
        setOperator,
        handleSortChange,
        sortDirection: sortModel?.sort,
        isSorted: !!sortModel,
        handleClearSort,
        isFilterOpen,
        toggleFilter,
        handleOnDateChangeValue,
        date,
        isFilterActive
    };
};